<template>
    <div class="container-fluid">
        <div class="row">
            <TableListShipping/>
        </div>
    </div>
</template>
<script setup>
import { ref, defineAsyncComponent } from 'vue'
const TableListShipping = defineAsyncComponent(() => import("@/components/theme/receipt-product/TableListShipping.vue"))
</script>